'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _immutable = require('immutable');

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

var initialState = (0, _immutable.fromJS)({
  events: {},
  persons: {}
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var pathToAdjudicators = ['adjudicators', action.event_id];

  var pathToParticipants = ['participants', action.event_id];

  var pathToPersonEvents = ['persons', action.person_id, 'feiseanna', action.feis_id, 'eligible'];

  var pathToRegistrations = ['persons', action.person_id, 'feiseanna', action.feis_id, 'registered'];

  var pathToParticipatedEvents = ['persons', action.person_id, 'feiseanna', action.feis_id, 'participated'];

  var pathToEventsResults = ['persons', action.person_id, 'feiseanna', action.feis_id, 'results'];

  var pathToEventAdjudicatorIds = ['adjudicators', action.event_id];

  var pathToEventScores = ['scores', action.event_id, action.adj_id];

  var pathToComments = ['comments', action.event_id, action.adj_id, action.person_id];

  var pathToDressChecks = ['dresschecks', action.event_id, action.adj_id];

  var pathToDressChecksForPerson = ['dresschecks', action.event_id];

  var pathToEventGroupFee = ['groupFee', action.event_id];

  var newState = void 0;

  switch (action.type) {

    case 'GET_EVENTS_RESULTS_BY_PERSON_START':
      {
        return state.setIn(pathToEventsResults, (0, _immutable.fromJS)({ loading: true }));
      }

    case 'GET_ELIG_EVENTS_FOR_PERSON_START':
      return state.setIn(pathToPersonEvents, (0, _immutable.fromJS)({ loading: true }));

    case 'GET_ELIG_EVENTS_FOR_PERSON':
      // add an array of eligible event ids for the person
      _newState = state.setIn(pathToPersonEvents, (0, _immutable.fromJS)(action.payload.map(function (e) {
        return e.id;
      })));

      // add in all events to the cache, so it exists but one place in memory
      action.payload.map(function (e) {
        return _newState = _newState.setIn(['one', e.id], (0, _immutable.fromJS)(e));
      });

      return _newState;

    case 'GET_RESULTS_BY_PERSON':
      {
        state = state.setIn(pathToEventsResults, (0, _immutable.fromJS)(action.payload.map(function (e) {
          return e.id;
        })));
        return action.payload.reduce(function (state, event) {
          return state.setIn(['one', event.id], (0, _immutable.fromJS)(event)).setIn(['persons', action.person_id, event.id, 'placements'], (0, _immutable.Map)({ placement: event.score.placement })).setIn(['persons', action.person_id, event.id, 'placed'], (0, _immutable.fromJS)(event.score.placed));
        }, state);
      };

    case 'GET_EVENT_PLACEMENTS':
      {
        return state.setIn([action.event_id, 'placements'], (0, _immutable.fromJS)(action.payload));
      };

    case 'GET_EVENT_ADJUDICATORS_START':
      return state.setIn(pathToAdjudicators, (0, _immutable.fromJS)({ loading: true }));

    case 'GET_EVENT_ADJUDICATORS':
      {
        return state.setIn(pathToEventAdjudicatorIds, (0, _immutable.fromJS)(action.payload.map(function (a) {
          return a.id;
        }))).deleteIn(pathToAdjudicators.concat(['loading']));
      };

    case 'GET_ALL_EVENT_SCORES_START':
      {
        return state.setIn(pathToAdjudicators, (0, _immutable.fromJS)({ loading: true }));
      };

    case 'GET_ALL_EVENT_SCORES':
      {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          var _loop = function _loop() {
            var adjudicator = _step.value;

            // group comments by person
            var commentIdsByPerson = {};
            adjudicator.comments.forEach(function (comment) {
              var pid = comment.pid;
              commentIdsByPerson[pid] = [].concat(_toConsumableArray(commentIdsByPerson[pid] || []), [comment.id]);
            });
            // set comment state
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = Object.entries(commentIdsByPerson)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _step2$value = _slicedToArray(_step2.value, 2),
                    person_id = _step2$value[0],
                    _commentIds = _step2$value[1];

                state = state.setIn(['comments', action.event_id, adjudicator.id, person_id], (0, _immutable.fromJS)(_commentIds));
              }

              // dress checks
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            adjudicator.dress_checks.forEach(function (dress_check) {
              state = state.setIn(['dresschecks', action.event_id, adjudicator.id, dress_check.pid], (0, _immutable.fromJS)(dress_check.id));
            });

            // scoresheets
            adjudicator.scores.forEach(function (scores) {
              var scoreIds = scores.scores.map(function (s) {
                return s.id;
              });
              state = state.setIn(['scores', action.event_id, adjudicator.id, scores.person], (0, _immutable.fromJS)(scoreIds));
            });
          };

          for (var _iterator = action.payload[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            _loop();
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return state.setIn(pathToAdjudicators, (0, _immutable.fromJS)(action.payload.map(function (a) {
          return a.id;
        }))).deleteIn(pathToAdjudicators.concat(['loading']));
      }

    case 'GET_PARTICIPANTS_START':
      return state.setIn(pathToParticipants, (0, _immutable.fromJS)({ loading: true }));

    case 'GET_PARTICIPANTS':
      return state.setIn(pathToParticipants, (0, _immutable.fromJS)(action.payload));

    case 'GET_EVENTS':
      return (0, _immutable.fromJS)(action.payload).reduce(function (state, ev) {
        return state.setIn(['one', ev.get('id')], ev);
      }, state);

    case 'UPDATE_GROUP_FEE_ASSIGNED_TO_EVENT':
      return state.updateIn(['one', action.event_id], function (event) {
        return (0, _immutable.fromJS)(_extends({}, event.toJS(), { groupFeeId: action.payload.id }));
      });

    case 'DELETE_GROUP_FEE_ASSIGNED_TO_EVENT':
      return state.updateIn(['one', action.event_id], function (event) {
        return (0, _immutable.fromJS)(_extends({}, event.toJS(), { groupFeeId: undefined }));
      });

    case 'GET_EVENTS_WITH_STATUS':
      return (0, _immutable.fromJS)(action.payload).reduce(function (state, ev) {
        return state.setIn(['one', ev.get('id')], ev);
      }, state).setIn(['byStatus', action.status, action.feis_id], (0, _immutable.fromJS)(action.payload.map(function (event) {
        return event.id;
      })));

    case 'GET_EVENTS_IN_RESULTS':
      var _newState = state;
      ['placements', 'recall'].forEach(function (k) {
        if (action.payload[k]) {
          _newState = (0, _immutable.fromJS)(action.payload[k]).reduce(function (newState, ev) {
            return newState.setIn(['one', ev.get('id')], ev);
          }, _newState).setIn(['byStatus', k === 'placements' ? 'RES' : 'RCL', action.feis_id], (0, _immutable.fromJS)(action.payload[k].map(function (event) {
            return event.id;
          })));
        }
      });
      return _newState;

    case 'CREATE_EVENT':
      return state.setIn(['one', action.payload.id], (0, _immutable.fromJS)(action.payload));

    case 'GET_EVENT':
    case 'OPEN_EVENT':
    case 'CLOSE_EVENT':
    case 'SEND_EVENT_TO_TABS':
    case 'SEND_EVENT_TO_QA':
      return state.setIn(['one', action.event_id], (0, _immutable.fromJS)(action.payload));

    case 'UPDATE_EVENT':
      return state.updateIn(['one', action.event_id], function (map) {
        return (0, _immutable.fromJS)(_extends({}, (map || (0, _immutable.Map)()).toJS(), action.payload));
      }).updateIn(['byStatus', 'ADJ', action.feis_id], function (list) {
        return (list || (0, _immutable.List)()).filter(function (event_id) {
          return event_id !== action.event_id;
        });
      }).updateIn(['byStatus', 'QA', action.feis_id], function (list) {
        return (list || (0, _immutable.List)()).filter(function (event_id) {
          return event_id !== action.event_id;
        });
      }).updateIn(['byStatus', 'TABS', action.feis_id], function (list) {
        return (list || (0, _immutable.List)()).filter(function (event_id) {
          return event_id !== action.event_id;
        });
      }).updateIn(['byStatus', 'RCL', action.feis_id], function (list) {
        return (list || (0, _immutable.List)()).filter(function (event_id) {
          return event_id !== action.event_id;
        });
      }).updateIn(['byStatus', 'RES', action.feis_id], function (list) {
        return (list || (0, _immutable.List)()).filter(function (event_id) {
          return event_id !== action.event_id;
        });
      }).updateIn(['byStatus', action.payload.status, action.feis_id], function (list) {
        return (list || (0, _immutable.List)()).concat(action.event_id);
      });

    case 'SPLIT_EVENT':
      return state.deleteIn(pathToParticipants).deleteIn(['one', action.event_id]).setIn(['one', action.payload[0].id], (0, _immutable.fromJS)(action.payload[0])).setIn(['one', action.payload[1].id], (0, _immutable.fromJS)(action.payload[1]));

    case 'MERGE_EVENT':
      return state.deleteIn(pathToParticipants).deleteIn(['one', action.ev_a_id]).deleteIn(['one', action.ev_b_id]).setIn(['one', action.payload.id], (0, _immutable.fromJS)(action.payload));

    case 'DELETE_EVENT':
      return state.deleteIn(pathToParticipants).deleteIn(['one', action.event_id]);

    case 'DELETE_ELIG_EVENTS_FOR_PERSON':
      return state.deleteIn(['persons', action.person_id]);

    case 'CHECKIN_PARTICIPANT':
    case 'CHECKOUT_PARTICIPANT':
    case 'UPDATE_REGISTRATION':
      var participantsArray = state.getIn(pathToParticipants) || (0, _immutable.List)();
      return state.setIn(pathToParticipants, participantsArray.map(function (participant) {
        if (action.payload.person.id === participant.get('id')) {
          var participantMap = participant.get('reg') || (0, _immutable.Map)();
          var reg = participantMap.merge((0, _immutable.fromJS)({
            is_checked_in: action.payload.is_checked_in,
            archived: action.payload.archived,
            slip_jig: action.payload.slip_jig,
            treble_jig: action.payload.treble_jig,
            reel: action.payload.reel,
            hornpipe: action.payload.hornpipe,
            music_selection: action.payload.music_selection,
            tempo: action.payload.tempo
          }));
          return participant.mergeDeep({ reg: reg });
        }
        return participant;
      })).setIn(['one', action.event_id], (0, _immutable.fromJS)(action.payload.event));

    case 'GET_REGISTERED_DATA_FOR_PERSON_START':
      return state.setIn(pathToRegistrations, (0, _immutable.fromJS)({ loading: true }));

    case 'GET_REGISTERED_DATA_FOR_PERSON':
      return action.payload.reduce(function (state, e) {
        return state.setIn(['one', e.event.id], (0, _immutable.fromJS)(e.event));
      }, state).setIn(pathToRegistrations, (0, _immutable.fromJS)(action.payload.map(function (p) {
        return p.event.id;
      })));

    case 'CREATE_REGISTRATION':
      var registrations = state.getIn(pathToRegistrations) || (0, _immutable.List)();
      var participants = state.getIn(['participants', action.payload.event.id]) || (0, _immutable.List)();
      var _action$payload = action.payload,
          created_at = _action$payload.created_at,
          creator = _action$payload.creator,
          archived = _action$payload.archived;

      action.payload.person.reg = { archived: archived, created_at: created_at, creator: creator };

      return state.setIn(pathToRegistrations, registrations.push((0, _immutable.fromJS)(action.payload.event.id))).setIn(['participants', action.payload.event.id], participants.push((0, _immutable.fromJS)(action.payload.person)));

    case 'GET_SCORESHEET_START':
      return state.setIn(pathToEventScores, (0, _immutable.fromJS)({ loading: true }));

    case 'GET_SCORESHEET':
      {
        state = state.deleteIn(pathToEventScores.concat('loading'));
        action.payload.forEach(function (data) {
          var scores = data.scores.map(function (s) {
            return s.id;
          });
          state = state.setIn(pathToEventScores.concat([data.person]), (0, _immutable.fromJS)(scores));
        });
        return state;
      }

    case 'DELETE_EVENT_SCORES_BY_ADJUDICATOR':
      return state.deleteIn(pathToEventScores);

    case 'CREATE_SCORE':
    case 'UPDATE_SCORE':
      var scoresInStore = state.getIn(['scores', action.event_id, action.adj_id, action.person_id]);
      if (!(scoresInStore || (0, _immutable.List)()).includes(action.payload.id)) {
        return state.updateIn(['scores', action.event_id, action.adj_id, action.person_id], function (scores) {
          return (scores || (0, _immutable.List)()).concat(action.payload.id);
        });
      }
      return state;

    case 'DELETE_SCORE':
      _newState = state.updateIn(['scores', action.event_id, action.adj_id, action.person_id], function (scores) {
        return scores.filter(function (score_id) {
          return score_id !== action.score_id;
        });
      });
      if (_newState.getIn(['scores', action.event_id, action.adj_id, action.person_id]).size === 0) {
        return _newState.deleteIn(['scores', action.event_id, action.adj_id, action.person_id]);
      }
      return _newState;

    case 'GET_RESULTS':
      var eventIds = new Set(action.payload.map(function (data) {
        return data.event.id;
      }));
      return action.payload.reduce(function (state, data) {
        return state.setIn(['one', data.event.id], (0, _immutable.fromJS)(data.event)).setIn(['persons', action.person_id, data.event.id, 'placements'], (0, _immutable.fromJS)(data.participant));
      }, state).setIn(pathToParticipatedEvents, (0, _immutable.fromJS)(Array.from(eventIds)));

    case 'GET_COMMENTS_START':
      return state.setIn(pathToComments, (0, _immutable.fromJS)({ loading: true }));

    case 'CREATE_COMMENT':
    case 'UPDATE_COMMENT':
      return state.updateIn(pathToComments, function (comments) {
        return (comments || (0, _immutable.List)()).concat((0, _immutable.fromJS)(action.payload.id));
      });

    case 'GET_COMMENTS':
      state = state.deleteIn(pathToComments);
      var commentIds = action.payload.map(function (data) {
        return data.comments.id;
      });
      return state.setIn(pathToComments, (0, _immutable.fromJS)(commentIds));

    case 'DELETE_COMMENTS':
      return state.deleteIn(pathToComments);

    case 'GET_DRESS_CHECKS_START':
      return state.setIn(pathToDressChecks, (0, _immutable.fromJS)({ loading: true }));

    case 'CREATE_DRESS_CHECK':
    case 'UPDATE_DRESS_CHECK':
      return state.setIn([].concat(pathToDressChecks, [action.person_id]), (0, _immutable.fromJS)(action.payload.id));

    case 'GET_DRESS_CHECKS':
      state = state.deleteIn(pathToDressChecks);
      var newStateDressCheck = state;
      action.payload.forEach(function (p) {
        newStateDressCheck = newStateDressCheck.setIn([].concat(pathToDressChecks, [p.pid]), (0, _immutable.fromJS)(p.id));
      });
      return newStateDressCheck;

    case 'GET_DRESS_CHECK':
      state = state.deleteIn(pathToDressChecks);
      newStateDressCheck = state;
      action.payload.forEach(function (d) {
        newStateDressCheck = newStateDressCheck.setIn([].concat(pathToDressChecksForPerson, [d.adjId, d.pid]), (0, _immutable.fromJS)(d.id));
      });
      return newStateDressCheck;

    case 'DELETE_DRESS_CHECK':
      return state.deleteIn([].concat(pathToDressChecks, [action.person_id]));

    case 'GET_EVENT_SCORES_START':
      {
        return state.setIn(pathToEventScores, (0, _immutable.fromJS)({ loading: true }));
      }

    case 'GET_EVENT_SCORES':
      {
        state = state.deleteIn(pathToEventScores);
        action.payload.forEach(function (data) {
          var scores = data.scores.map(function (s) {
            return s.id;
          });
          state = state.setIn(pathToEventScores.concat([data.person]), (0, _immutable.fromJS)(scores));
        });
        return state;
      }

    case 'GET_RESULTS_BY_PERSON':
      {
        state = state.setIn(pathToEventsResults, (0, _immutable.fromJS)(action.payload.map(function (e) {
          return e.id;
        })));
        return action.payload.reduce(function (state, event) {
          return state.setIn(['one', event.id], (0, _immutable.fromJS)(event)).setIn(['persons', action.person_id, event.id, 'placements'], (0, _immutable.Map)({ placement: event.score.placement })).setIn(['persons', action.person_id, event.id, 'placed'], (0, _immutable.fromJS)(event.score.placed));
        }, state);
      }

    case 'GET_EVENT_PLACEMENTS':
      {
        return state.setIn([action.event_id, 'placements'], (0, _immutable.fromJS)(action.payload));
      }

    case 'REGISTER_FOR_EVENT':
      {
        return state.setIn(pathToRegistrations, (state.getIn(pathToRegistrations) || (0, _immutable.List)()).push(action.event_id));
      }

    case 'UNREGISTER_FOR_EVENT':
      {
        return state.setIn(pathToRegistrations, (state.getIn(pathToRegistrations) || (0, _immutable.List)()).filter(function (eid) {
          return eid !== action.event_id;
        }));
      }

    case 'UNREGISTER_FOR_ALL_EVENTS':
      {
        return state.setIn(pathToRegistrations, (0, _immutable.List)());
      }

    case 'ORDER_PARTICIPANTS':
      {
        var updatedOrderParticipants = action.orderedParticipants.map(function (o, idx) {
          o.reg.order = idx;
          return o;
        });
        return state.setIn(pathToParticipants, (0, _immutable.fromJS)(updatedOrderParticipants));
      }

    case 'GET_EVENT_ADJUDICATORS':
      {
        return state.setIn(pathToEventAdjudicatorIds, (0, _immutable.fromJS)(action.payload.map(function (a) {
          return a.id;
        })));
      }

    case 'ASSOCIATE_MEDAL_ROUND_WITH_ADJUDICATOR':
      {
        return state.setIn(['rounds', action.event_id, action.payload.medalRound], (0, _immutable.fromJS)({ 'adjudicator': action.aid, 'round': action.payload.round }));
      }

    case 'GET_MEDAL_ROUND_START':
      {
        return state.setIn(['rounds', action.event_id, action.payload.medalround.round, 'adjudicator'], (0, _immutable.fromJS)({ loading: true }));
      }

    case 'GET_EVENT_MEDAL_ROUNDS_START':
      {
        return state.setIn(['rounds', action.event_id], (0, _immutable.fromJS)({ loading: true }));
      }

    case 'GET_MEDAL_ROUND':
      {
        return state.setIn(['rounds', action.event_id, action.payload.medalround.medalRound], (0, _immutable.fromJS)({ 'adjudicator': action.payload.adj.id, 'round': action.payload.medalround.round }));
      }

    case 'GET_EVENT_MEDAL_ROUNDS':
      {
        _newState = state.deleteIn(['rounds', action.event_id]);
        action.payload.map(function (data) {
          return _newState = _newState.setIn(['rounds', action.event_id, data.medalround.medalRound], (0, _immutable.fromJS)({ 'adjudicator': data.adj.id, 'round': data.medalround.round }));
        });

        return _newState;
      }

    case 'GET_GROUP_FEE_ASSIGNED_TO_EVENT_START':
      return state.setIn(['groupFee', action.event_id], (0, _immutable.fromJS)({ loading: true }));

    case 'GET_GROUP_FEE_ASSIGNED_TO_EVENT':
      return state.setIn(['groupFee', action.event_id], (0, _immutable.fromJS)(action.payload));

    case 'GET_GROUP_FEE_ASSIGNED_TO_EVENT_ERROR':
      return state.deleteIn(['groupFee', action.event_id]);

    case 'UPDATE_GROUP_FEE_ASSIGNED_TO_EVENT':
      return state.setIn(['groupFee', action.event_id], (0, _immutable.fromJS)(action.payload));

    case 'DELETE_GROUP_FEE_ASSIGNED_TO_EVENT':
      return state.deleteIn(['groupFee', action.event_id]);

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/events/index.js
// module id = 692
// module chunks = 0